"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BugCatchSystem = void 0;
const gotti_1 = require("gotti");
const Constants_1 = require("../../../Shared/Constants");
class BugCatchSystem extends gotti_1.ClientSystem {
    constructor() {
        super(Constants_1.SYSTEMS.BUG_CATCH);
        this.fastforward = false;
        this.bugsWithinPlayer = [];
        this._isSwinging = false;
        this.playerHasNetEquipped = false;
        this.needReset = false;
        this.swingCooldown = 0;
        const handleBugCollision = (colA, colB) => {
            const player = colA.gameObject.entity;
            const bug = colB.gameObject.entity;
            if (!this.bugsWithinPlayer.includes(bug)) {
                this.bugsWithinPlayer.push(bug);
            }
        };
        this.bugCatchPlugin = {
            type: 'collision',
            name: 'bugcatch',
            tagAs: [Constants_1.COLLIDER_TAGS.in_front_of_client_player],
            tagBs: [Constants_1.COLLIDER_TAGS.bug],
            onCollision: handleBugCollision,
            onCollisionStart: handleBugCollision,
        };
    }
    onStart() {
        this.globals.tileWorld.use(this.bugCatchPlugin);
        this.addApi(this.isSwinging);
        this.addApi(this.netIsEquipped);
    }
    isSwinging() {
        return this._isSwinging;
    }
    onClear() {
    }
    onLocalMessage(message) {
        var _a, _b, _c, _d;
        switch (message.type) {
            case Constants_1.MESSAGES.EQUIP_ITEM:
                const ani = this.globals.clientPlayer.getComponent(Constants_1.SYSTEMS.PLAYER_ANIMATION);
                if (message.data === 'net') {
                    if (this.playerHasNetEquipped) {
                        this.playerHasNetEquipped = false;
                        (_b = (_a = this.mountedAttachment) === null || _a === void 0 ? void 0 : _a.skeleton) === null || _b === void 0 ? void 0 : _b.unmountAttachment('net');
                        this.mountedAttachment = null;
                        this._isSwinging = false;
                    }
                    else {
                        setTimeout(() => {
                            var _a;
                            this.playerHasNetEquipped = true;
                            this.mountedAttachment = (_a = ani === null || ani === void 0 ? void 0 : ani.skeleton) === null || _a === void 0 ? void 0 : _a.mountAttachment('net', 'net');
                        }, 0);
                    }
                }
                else if (this.mountedAttachment) {
                    this.playerHasNetEquipped = false;
                    (_d = (_c = this.mountedAttachment) === null || _c === void 0 ? void 0 : _c.skeleton) === null || _d === void 0 ? void 0 : _d.unmountAttachment('net');
                    this.mountedAttachment = null;
                    this._isSwinging = false;
                }
        }
    }
    canSwingNet() {
        var _a, _b;
        return !!((_b = (_a = this.globals.clientPlayer) === null || _a === void 0 ? void 0 : _a.getComponent(Constants_1.SYSTEMS.PLAYER_ANIMATION)) === null || _b === void 0 ? void 0 : _b.canPlayActionAnimation())
            && this.swingCooldown === 0 && !this.$api.isInventoryOpen() && !this.$api.isInDialogue();
    }
    tryingToSwing() {
        var _a;
        return ((_a = this.globals.clientPlayer) === null || _a === void 0 ? void 0 : _a.playerInput.grab) && this.playerHasNetEquipped;
    }
    onPeerMessage(peerId, message) {
    }
    onServerMessage(message) {
    }
    onEntityRemovedComponent(entity, component) {
        this.playerIsSwingingNet = false;
    }
    onEntityAddedComponent(entity, component) {
        const skel = entity.getComponent(Constants_1.SYSTEMS.PLAYER_ANIMATION).skeleton;
        const regAniListeners = (_skel) => {
            if (this.fastforward)
                return;
            _skel.onStart((actionName, track) => {
                if (!track === _skel.baseTrack)
                    return;
                if (actionName === 'walk') {
                    this._isSwinging = false;
                }
                else if (actionName === 'swing_net' && this.playerHasNetEquipped) {
                    this._isSwinging = true;
                }
                else {
                    this._isSwinging = false;
                }
            });
            _skel.onEnd((actionName, track) => {
                if (this.fastforward)
                    return;
                if (!track === _skel.baseTrack)
                    return;
                if (actionName === 'swing_net' && this.playerHasNetEquipped) {
                    this.mountedAttachment = _skel.mountAttachment('net', 'net');
                    this._isSwinging = false;
                }
            });
        };
        !skel ? entity.once('skeleton-ready', regAniListeners) : regAniListeners(skel);
    }
    netIsEquipped() {
        return this.playerHasNetEquipped;
    }
    update(delta) {
        if (this.swingCooldown) {
            this.swingCooldown = Math.max(this.swingCooldown - delta, 0);
        }
        if (this.tryingToSwing() && this.canSwingNet()) {
            this.swingCooldown = .5;
            // todo: play bug swing noise
            //this.$api.playSound('swing');
            if (this.mountedAttachment) {
                this.mountedAttachment.skeleton.unmountAttachment('net');
                this.mountedAttachment = null;
            }
            this.globals.clientPlayer.getComponent(Constants_1.SYSTEMS.PLAYER_ANIMATION).skeleton.play('swing_net', null, { loop: false });
            if (this.bugsWithinPlayer.length) {
                for (let i = 0; i < this.bugsWithinPlayer.length; i++) {
                    this.$api.addItem(this.bugsWithinPlayer[i].bugType, 1);
                    this.destroyEntity(this.bugsWithinPlayer[i]);
                }
                // todo: play catch bug noise
                //this.$api.playSound('catchbug');
            }
        }
        this.bugsWithinPlayer.length = 0;
    }
}
exports.BugCatchSystem = BugCatchSystem;
//# sourceMappingURL=module.js.map